import React, {useCallback, useEffect, useState} from 'react'
import {useCognitoAuth} from '../auth/core/CognitoAuth'
import {resolveTotpMfaEnabled} from '../auth/core/totpMfa'
import {MfaTotpSettingsModal} from './MfaTotpSettingsModal'

/**
 * Authenticator app (TOTP) MFA status + manage modal (Settings page /admin).
 */
export const TotpMfaAccountRow: React.FC = () => {
  const {cognitoAuth} = useCognitoAuth()
  const [modalOpen, setModalOpen] = useState(false)
  const [totpEnabled, setTotpEnabled] = useState<boolean | null>(null)

  const refreshStatus = useCallback(() => {
    if (!cognitoAuth) {
      setTotpEnabled(null)
      return
    }
    void resolveTotpMfaEnabled(cognitoAuth).then(setTotpEnabled)
  }, [cognitoAuth])

  useEffect(() => {
    refreshStatus()
  }, [refreshStatus])

  return (
    <>
      <div className='notice d-flex bg-light-primary rounded border-primary border border-dashed p-6 mb-5'>
        <i className='fas fa-mobile-screen-button text-primary fs-2x me-4' />
        <div className='d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap'>
          <div className='mb-3 mb-md-0 fw-bold'>
            <h4 className='text-gray-800 fw-bolder'>Authenticator app two-factor authentication</h4>
            <div className='fs-6 text-gray-600 pe-7'>
              Optional verification with a code from an authenticator app when you sign in with
              email and password. Works without mobile reception and takes priority over SMS if both
              are on.
            </div>
            {totpEnabled !== null && cognitoAuth && (
              <div className='fs-7 mt-2'>
                <span className='badge bg-light text-gray-800 me-2'>Authenticator app</span>
                {totpEnabled ? (
                  <span className='text-success'>On</span>
                ) : (
                  <span className='text-muted'>Off</span>
                )}
              </div>
            )}
          </div>
          <button
            type='button'
            className='btn btn-primary align-self-center text-nowrap'
            disabled={!cognitoAuth}
            onClick={() => setModalOpen(true)}
          >
            {totpEnabled ? 'Manage' : 'Enable'}
          </button>
        </div>
      </div>
      <MfaTotpSettingsModal
        show={modalOpen}
        onHide={() => setModalOpen(false)}
        onStatusChanged={refreshStatus}
      />
    </>
  )
}
